import * as Types from "../Constants/AllConstants";

const defaultState = {};

// Application Mutation Reducer (handles create, update, change sender IDs, change key)
export const ApplicationMutationReducer = (state = defaultState, action) => {
  switch (action.type) {
    case Types.CREATE_APPLICATION_REQUEST:
    case Types.UPDATE_APPLICATION_REQUEST:
    case Types.CHANGE_EMAIL_SENDER_ID_REQUEST:
    case Types.CHANGE_SMS_SENDER_ID_REQUEST:
    case Types.CHANGE_KEY_REQUEST:
      return { loading: true };
    
    case Types.CREATE_APPLICATION_SUCCESS:
    case Types.UPDATE_APPLICATION_SUCCESS:
    case Types.CHANGE_EMAIL_SENDER_ID_SUCCESS:
    case Types.CHANGE_SMS_SENDER_ID_SUCCESS:
    case Types.CHANGE_KEY_SUCCESS:
      return { loading: false, success: true, application: action.payload };
    
    case Types.CREATE_APPLICATION_FAIL:
    case Types.UPDATE_APPLICATION_FAIL:
    case Types.CHANGE_EMAIL_SENDER_ID_FAIL:
    case Types.CHANGE_SMS_SENDER_ID_FAIL:
    case Types.CHANGE_KEY_FAIL:
      return { loading: false, error: action.payload };
    
    case Types.APPLICATION_MUTATION_RESET:
      return defaultState;
    
    default:
      return state;
  }
};

// MY APPLICATIONS (paged)
export const MyApplicationsReducer = (state = { applications: [] }, action) => {
  switch (action.type) {
    case Types.MY_APPLICATIONS_REQUEST:
      return { loading: true, applications: [] };
    
    case Types.MY_APPLICATIONS_SUCCESS:
      return {
        loading: false,
        applications: action.payload.content,
        page: action.payload.number,
        pages: action.payload.totalPages,
      };
    
    case Types.MY_APPLICATIONS_FAIL:
      return { loading: false, error: action.payload };
    
    default:
      return state;
  }
};

// ALL MY APPLICATIONS (non-paged)
export const AllMyApplicationsReducer = (state = { applications: [] }, action) => {
  switch (action.type) {
    case Types.ALL_MY_APPLICATIONS_REQUEST:
      return { loading: true, applications: [] };
    
    case Types.ALL_MY_APPLICATIONS_SUCCESS:
      return { loading: false, applications: action.payload };
    
    case Types.ALL_MY_APPLICATIONS_FAIL:
      return { loading: false, error: action.payload };
    
    default:
      return state;
  }
};